const allFields = document.querySelectorAll('.gfield');

allFields.forEach(gfield => {
  if (gfield.querySelector('input[type=text], textarea') != null) {
    gfield.classList.add('text-field');
  }
});

$('.text-field input').each(function() {
  $(this).on('focus', function() {
    $(this)
      .parent()
      .parent('.gfield')
      .addClass('active');
  });

  $(this).on('blur', function() {
    if (0 == $(this).val().length) {
      $(this)
        .parent()
        .parent('.gfield')
        .removeClass('active');
    }
  });

  if ('' != $(this).val()) {
    $(this)
      .parent('.css')
      .addClass('active');
  }
});
$('textarea').each(function() {
  $(this).on('focus', function() {
    $(this)
      .parent()
      .parent('.gfield')
      .addClass('active');
  });

  $(this).on('blur', function() {
    if (0 == $(this).val().length) {
      $(this)
        .parent()
        .parent('.gfield')
        .removeClass('active');
    }
  });

  if ('' != $(this).val()) {
    $(this)
      .parent('.css')
      .addClass('active');
  }
});
